<template>
	<div class="container mx-0">
		<div class="row">
			<div class="col-12 mb-4 d-flex">
				<svg-image
					:src="'/svg/' + resource_group + '/chevron-left.svg'"
					:auto_hover="true"
					:spaced="true"
					v-on:click="back()"
				>
					<span class="my-auto">Compliance Checks</span>
				</svg-image>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<div class="flex-table d-inline-block">
					<div class="flex-table--cell w-auto">
						<h5>Name:</h5> <h5 class="ml-3">{{location.name}}</h5>
					</div>
					<div class="flex-table--cell w-auto">
						<h5>Level:</h5> <h5 class="ml-3">{{location.level}}</h5>
					</div>
					<div class="flex-table--cell w-auto">
						<h5>Type:</h5> <h5 class="ml-3">{{location.type}}</h5>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-4">
			<div class="col-12">
				<collapsable
					:title="question.title"
					:key="question.id"
					:show="false"
					v-for="question in compileQuestionsForSubmission()"
				>
					<template slot="header_content">
						<svg-image
							v-if="question.answers.length"
							:src="'/svg/' + resource_group + '/' + (answerAsset(question.answers[0]))"
							class="d-inline-flex"
							:color="answerColor(question.answers[0])"
						></svg-image>
					</template>

					<template slot="content">
						<div class="certificate-card" v-if="index === 0 || has_permission" v-for="(answer, index) in question.answers">
							<div class="certificate-card--collapse-header">
								<div class="certificate-card--collapse-header-title-wrapper w-100 d-flex justify-content-between">
									<div class="d-flex">
										<svg-image
											:src="'/svg/' + resource_group + '/file.svg'"
											class="d-inline-flex"
											:color="answerColor(answer)"
										></svg-image>

										<h2
											class="certificate-card--collapse-header-title"
											v-bind:class="answerColor(answer)"
										>
											{{getAnswerTitle(answer)}}
										</h2>
									</div>

									<div class="badge badge--sm badge--light-grey">{{answer.user.full_name}}</div>
								</div>
							</div>

							<div class="row">
								<div class="col-12">
									<gallery-view-component
										title="Images"
										col_size="medium"
										:photos="answer.images"
									></gallery-view-component>
								</div>
								<div class="col-12">
									<h5 class="certificate-card--collapse-footer-title image-gallery--content-title">Comments</h5>
									<span class="certificate-card--collapse-footer-subtitle">{{ answer.comments }}</span>
								</div>
							</div>

							<div class="certificate-card--collapse-footer">

							</div>
						</div>
						<div  v-if="!question.answers.length" class="p-3">
							<h6>Not answered</h6>
						</div>
					</template>
				</collapsable>
			</div>
		</div>
	</div>
</template>

<script>
	import Collapsable from "../ListComponent/Collapsable";
	import GalleryViewComponent from "../general_components/GalleryViewComponent";
	export default {
		name: "QualityAssuranceQuestionnaireSubmissions",
		components: {GalleryViewComponent, Collapsable},
		props: {
			location: {
				required: true
			},
			back_url: {
				required: true,
				type: String
			},
			has_permission: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			back(){
				window.location.href = this.back_url;
			},

			compileQuestionsForSubmission(){
				const groups = this.location.question_answers_groups;
				const questions = Object.assign([], this.questions);

				questions.forEach(question => {
					question.answers = [];
					groups.forEach(group => {
						if (group.quality_assurance_question_id === question.id)
							question.answers.push(...group.answers);
					});
				});

				return questions;
			},

			getAnswerTitle(answer){
				return `${answer.acceptable_text}, ${answer.submitted_at_formatted}`;
			},
			answerAsset(answer){
				if (answer.acceptable === null)
					return 'answer_adequate.svg';
				else
					return answer.acceptable ? 'answer_correct.svg' : 'answer_incorrect.svg';
			},
			answerColor(answer){
				if (answer.acceptable === null)
					return 'adequate';
				else
					return answer.acceptable ? 'positive' : 'negative';
			},
		},

		computed: {
			questions(){
				return this.location.section.questions;
			}
		}
	}
</script>